/**
 * `window.dataLayer` + the `gtag()` shim that every Google loader (gtag.js, GTM) expects to
 * already exist. Safe to emit more than once — the shim is only installed if it is missing.
 */
export const GTAG_SHIM_SNIPPET = `
            window.dataLayer = window.dataLayer || [];
            window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };`;

/**
 * Google Consent Mode v2 bootstrap, shared by the gtag.js and GTM loaders.
 *
 * A page can run both loaders at once (a distributor's own GA4 property plus their GTM
 * container), and each needs the consent signals on the dataLayer before it runs — but the
 * `default`/`update` pair must only be emitted once, because a `default` arriving after an
 * `update` is not a well-defined state. The flag guard makes the snippet idempotent, so the
 * loaders can be rendered in any order without coordinating.
 *
 * Only emit this from a tree that is already gated behind granted analytics consent: it
 * declares everything `denied` and immediately upgrades to `granted` ("basic" consent mode),
 * which is what Google requires to populate demographics/audience reports for EEA traffic.
 */
export const GOOGLE_CONSENT_MODE_SNIPPET = `${GTAG_SHIM_SNIPPET}
            if (!window.__cineamoConsentModeInitialized) {
                window.__cineamoConsentModeInitialized = true;
                window.gtag('consent', 'default', {
                    ad_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                    analytics_storage: 'denied'
                });
                window.gtag('consent', 'update', {
                    ad_storage: 'granted',
                    ad_user_data: 'granted',
                    ad_personalization: 'granted',
                    analytics_storage: 'granted'
                });
            }`;
